import { Directive, ViewContainerRef } from '@angular/core';

/**
 * This directive provides an "anchor point" for loading components dynamically
 */
@Directive({
    selector: '[appComponentAnchor]',
    standalone: false
})
export class ComponentAnchorDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
